import api from '../index'

// 管理员信息接口
export interface AdminProfile {
  id: number
  username: string
  name: string
  phone: string
  email?: string
  gender?: 0 | 1 | 2
  employment_status?: 1 | 2
  avatar?: string
  remark?: string
}

// 更新个人信息参数（不包含密码，密码在安全设置中单独修改）
export interface UpdateProfileParams {
  username: string
  name: string
  phone: string
  email?: string
  gender?: 0 | 1 | 2
  employment_status?: 1 | 2
  avatar?: string
  remark?: string
}

export default {
  // 登录
  login: (data: {
    username: string
    password: string
    remember?: boolean
  }) => api.post('login', data),

  // 获取当前用户信息
  profile: () => api.get('user/info'),

  // 登出
  logout: () => api.post('logout'),

  // 刷新令牌
  refresh: () => api.post('refresh'),

  // 修改自己的密码
  passwordEdit: (data: {
    old_password: string
    new_password: string
    confirm_password: string
  }) => api.put('change-password', data),

  // 更新个人信息
  updateProfile: (id: number, data: UpdateProfileParams) => api.put(`system/system-admins/${id}`, data),

  // 获取权限（暂时保留mock）
  permission: () => api.get('user/permission', {
    baseURL: '/mock/',
  }),
}
